import { defineNuxtPlugin } from '#app'
import { Splitpanes, Pane } from 'splitpanes'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('Splitpanes', Splitpanes)
  nuxtApp.vueApp.component('Pane', Pane)
})
